import { googleAnalyticsLib } from 'freedom-shared';

import { appConfig } from '@/shared/config';

export const withGoogleAnalytics = () => {
  const shouldUseDebugMode =
    appConfig.isDevRuntimeEnv || appConfig.isStagRuntimeEnv;
  googleAnalyticsLib.init(
    appConfig.GOOGLE_ANALYTICS_TAG_ID,
    shouldUseDebugMode,
  );
};
